import { useNavigate } from "react-router-dom";
import { Button,Modal } from "antd";
import { LayoutData } from "../Structur/Aconlayout";
import React, { useState,useEffect, useRef } from "react";


export const Logout = () => {
  const navigate = useNavigate();
  const defaultButtonRef = useRef(null);
  const { user, logout } = LayoutData();
  const handleLogout = async () => {
    await logout();
    navigate("/");
  };
  useEffect(() => {
    if (defaultButtonRef.current) {
      defaultButtonRef.current.focus();
    }
  }, []); // Leere Abhängigkeitsliste, um sicherzustellen, dass der Effekt nur einmal ausgeführt wird

  return (
    <>
      <div className="page">
        <center>
          <h1 style={{ color: "lightgray" }}>{user.name}</h1>
          <h3>Sind Sie sicher dass Sie sich nun auloggen möchten?</h3>
          <Button type="primary" block danger onClick={handleLogout} style={{maxWidth:220}} ref={defaultButtonRef}>
            Logout
          </Button>
        </center>
      </div>
    </>
  );
};


export const LogoutModal = () => {
  const [modal2Open, setModal2Open] = useState(true);
  const navigate = useNavigate();
  return (
    <>
      <Modal
        title="Auf Wiedersehen"
        width={400}
        centered
        open={modal2Open}
        cancelText="Schließen"
        onCancel={() => {
          setModal2Open(false);
          navigate("/");
        }}
        onOk={() => setModal2Open(false)}
        okText="-"
        okButtonProps={{style: { display: 'none' } }} // Hier wird der OK-Button ausgeblendet
        cancelButtonProps={{style:{display:'none'}}}
      >
        <Logout isModal={true} />
      </Modal>
    </>
  );
};
